import { Dispatcher } from './Dispatcher';
import { Constants } from './Constants';

import { Action, check } from '../../../../pdc-platform/src/ts/actions/AppActions';
import { IMarkedItems } from '../../../../pdc-platform/src/ts/Interfaces';
export { Action, check } from '../../../../pdc-platform/src/ts/actions/AppActions';

export module I {}

export class Actions {
    public getResourceTreeRoot(instanceId: string) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_RESOURCE_TREE_ROOT,
            instanceId
        });
    }

    public getResourceTreeRootFinish(instanceId: string, response) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_RESOURCE_TREE_ROOT_FINISH,
            instanceId,
            response
        });
    }

    public getData(instanceId, resid) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_DATA,
            instanceId,
            resid
        });
    }

    public zeroFlags(instanceId) {
        this.dispatcher.handleViewAction({
            actionType: Constants.ZERO_FLAGS,
            instanceId
        });
    }

    public getDataFinish(instanceId, response) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_DATA_FINISH,
            instanceId,
            response
        });
    }

    public loadFromFile(instanceId, fileName) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_FROM_FILE,
            instanceId,
            fileName
        });
    }

    public loadFromFileFinish(instanceId, response) {
        this.dispatcher.handleViewAction({
            actionType: Constants.LOAD_FROM_FILE_FINISH,
            instanceId,
            response
        });
    }

    public getDirContent(instanceId, dirid) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_DIR_CONTENT,
            instanceId,
            dirid
        });
    }

    public getDirContentFinish(instanceId, response) {
        this.dispatcher.handleViewAction({
            actionType: Constants.GET_DIR_CONTENT_FINISH,
            instanceId,
            response
        });
    }

    public create(instanceId, dirid, name, mimetype, data) {
        this.dispatcher.handleViewAction({
            actionType: Constants.CREATE,
            instanceId,
            dirid,
            name,
            mimetype,
            data
        });
    }

    public createFinish(instanceId, response, mimetype, data) {
        this.dispatcher.handleViewAction({
            actionType: Constants.CREATE_FINISH,
            instanceId,
            response,
            mimetype,
            data
        });
    }

    public delete(instanceId, dirid, resourceIDs: string[]) {
        this.dispatcher.handleViewAction({
            actionType: Constants.DELETE,
            instanceId,
            dirid,
            resourceIDs: resourceIDs
        });
    }

    public uploadData(instanceId, dirid, resourceID: string, mimetype, data) {
        this.dispatcher.handleViewAction({
            actionType: Constants.UPLOAD_DATA,
            instanceId,
            dirid: dirid,
            resourceID: resourceID,
            mimetype: mimetype,
            data: data
        });
    }

    public uploadDataFinish(instanceId, dirid, response) {
        this.dispatcher.handleViewAction({
            actionType: Constants.UPLOAD_DATA_FINISH,
            instanceId,
            dirid,
            response
        });
    }

    public resourceRenameStart(instanceId, resourceID: string) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RESOURCE_RENAME_START,
            instanceId,
            resourceID
        });
    }

    public resourceRenameFinish(instanceId, resourceID: string, newName: string) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RESOURCE_RENAME_FINISH,
            instanceId,
            resourceID,
            newName
        });
    }

    public resourceMoveStart(instanceId, resourceIDs: string[], toDirId) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RESOURCE_MOVE_START,
            instanceId,
            resourceIDs,
            toDirId
        });
    }

    public resourceMoveFinish(instanceId) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RESOURCE_MOVE_FINISH,
            instanceId
        });
    }

    public resourceCopyStart(instanceId, resourceIDs: string[], toDirId) {
        this.dispatcher.handleViewAction({
            actionType: Constants.RESOURCE_COPY_START,
            instanceId,
            resourceIDs,
            toDirId
        });
    }

    public setResourceSelected(instanceId, selectedResources: IMarkedItems) {
        this.dispatcher.handleViewAction({
            actionType: Constants.SET_RESOURCE_SELECTED,
            instanceId,
            selectedResources
        });
    }

    constructor(private dispatcher: Dispatcher) {}

    public static get(dispatcher: Dispatcher) {
        return new Actions(dispatcher);
    }
}
